import { Component, Input, OnInit } from '@angular/core';
import { AccountService } from 'src/app/services/account.service';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss']
})
export class SideNavComponent implements OnInit {
isDarkTheme: boolean = false;
@Input() hideOnHover: boolean = false;
@Input() moduleName: string = 'requests-analysis';

  constructor(
    private _service: ApiService,
    private accService: AccountService,
  ) {
    const now = new Date();

    this.currentTime = `${now.toLocaleDateString()} ${now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;


   }
  username
  currentTime
  ngOnInit(): void {
    this.username = sessionStorage.getItem('userName');
    this.isDarkTheme =
    localStorage.getItem("darktheme") == "dark" ? true : false;
    let html = document.querySelector('html');
    let lang: string = localStorage.getItem('lang') || 'en';
    html?.setAttribute('dir', lang == 'en' ? 'ltr' : 'rtl');
    html?.setAttribute('lang', lang == 'en' ? 'en' : 'ar');
    html?.setAttribute('data-theme', this.isDarkTheme == true ? 'dark' : 'light');

  }
  logout() {
    this._service.logOut(this.username).subscribe(
      (res) => {
        this.accService.logout();
      },
      (err) => {
      }
    );
  }

}
